import styles from "./index.module.css";

const STEPS = [
  {
    n: "01",
    title: "Tell us about your app",
    body: "Just chat. \"I made a Next.js thing for tracking plants.\" That's enough — we'll figure out the rest."
  },
  {
    n: "02",
    title: "Connect your code",
    body: 'Paste a GitHub link or click "Connect GitHub". If your code is on your laptop, we\'ll show you how to push it (yes, even what `git push` means).'
  },
  {
    n: "03",
    title: "We summon a server",
    body: "A small computer ($4/mo) gets created in the cloud — yours, no shared resources. Think of it as renting a tiny apartment for your app to live in."
  },
  {
    n: "04",
    title: "You get a real URL",
    body: "We hook it all up — HTTPS, monitoring, auto-redeploy on git push. You get a link to share. That's it."
  }
];

export const HowItWorks = () => (
  <section id="how" className={styles.section}>
    <div className={styles.sectionHead}>
      <div className={styles.sectionKicker}>how it works</div>
      <h2 className={styles.sectionTitle}>
        From localhost to <em>actual URL</em>, in 4 chats.
      </h2>
      <p className={styles.sectionSub}>
        We explain everything as we go. No Docker. No Terraform. No SSH. No tears.
      </p>
    </div>
    <div className={styles.howGrid}>
      {STEPS.map(s => (
        <div key={s.n} className={styles.howCard}>
          <div className={styles.howNum}>{s.n}</div>
          <div className={styles.howTitle}>{s.title}</div>
          <div className={styles.howBody}>{s.body}</div>
        </div>
      ))}
    </div>
  </section>
);
